import React, { ReactNode } from "react";
import classnames from "classnames";

// Styles
import Styles from "./DotSeparated.module.scss";

interface DotSeparatedTypes {
    nodes: ReactNode[];
    dotStyleClassName?: string;
    nodesClassName?: string;
    wrapperClassName?: string;
}
const DotSeparated = ({ nodes, dotStyleClassName, nodesClassName, wrapperClassName }: DotSeparatedTypes) => {
    return (
        <div className={classnames(Styles.DotSeparated, wrapperClassName)}>
            {nodes.map((node, idx) => (
                <div className={classnames(Styles.nodes, nodesClassName)} key={idx}>
                    {node}{" "}
                    {idx !== nodes.length - 1 ? (
                        <span className={classnames(Styles.dot, dotStyleClassName)}></span>
                    ) : (
                        ""
                    )}
                </div>
            ))}
        </div>
    );
};
export default DotSeparated;
